<template lang="pug">
md-input-container(:class='{ "md-input-invalid" : showRequiredError }', v-if='accounts.length > 1')
  label Account
  md-select(:multiple='false', v-model='selected', @selected='onAccountSelected', :disabled='!canEdit')
    md-option(v-for='account in accounts', :value='account._id' :key="account._id") {{ account.name }}
  span.md-error(v-show='showRequiredError') This field is required
md-input-container(v-else-if='accounts.length == 1')
  label Account
  md-select(:multiple='false', v-model='selected', :disabled='true')
    md-option(:selected='true', :value='accounts[0]._id') {{ accounts[0].name }}
</template>

<script>
  import accountService from '../../services/accountService';
  import { mapState, mapGetters } from 'vuex';

  export default {
    props: {
      canEdit: {
        type: Boolean,
        default: false
      },
      hideAccountId: {
        type: String,
        default: ''
      },
      value: {
        type: [String, Array]
      },
      showRequiredError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        accounts: []
      };
    },
    methods: {

      isAdmin() {

        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('Admin');
        }

        return false;
      },

      isAccountAdmin() {

        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('AccountAdmin');
        }

        return false;
      },

      isBaseUser() {
        // Check user has 'authorization' and Check user has 'roles'
        if (this.siteuser.authorization && this.siteuser.authorization.roles) {
          return this.siteuser.authorization.roles.includes('User') || !this.siteuser.authorization.roles.length;
        }

        return false;
      },

      onAccountSelected(value) {
        this.$emit('input', value);
      }
    },

    computed: {
      ...mapState({
        siteuser: state => state.user.siteuser
      })
    },

    mounted() {

      // when user is of role AccountAdmin or a Base User, don't call getList(), hide md-select, show just account name
      if (!this.isAdmin()) {
        accountService.get(this.siteuser.user_metadata.account_id)
        .then((response) => {
          this.accounts = [response.data.account];
          this.selected = this.accounts[0].id;
          this.value = this.selected;
          this.onAccountSelected(this.selected);
        })
        .catch(() => {
          this.$emit('getAccountsError');
        });
        return;
      }

      accountService.getFullList()
        .then((response) => {
          this.accounts = response.data.accounts.filter((account) => {
            if(this.hideAccountId.length && account._id === this.hideAccountId) {
              return false;
            }
            return true;
          });
        })
        .catch(() => {
          this.$emit('getAccountsError');
        });
    },
    watch: {
      value(newValue) {
        this.selected = newValue;
      }
    }
  };
</script>
<style scoped>
.md-input-disabled .md-select:not(.md-select-icon):after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/account/AccountSelector.vue